/*framework permissions*/
export const PERM_APP_CONFIGURATOR = 'Application-Configure';

/* new permissions */
export const PERM_PAGES_GENERAL_DASHBOARD = 'pages:generalDashboard';
export const PERM_PAGES_MAINTENANCE = 'Application-Maintenance';
